import { useEffect, useSyncExternalStore } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { EcosystemPage } from '@/pages/ecosystem';
import { ProductDetailPage } from '@/pages/product-detail';
import { DoraPage } from '@/pages/dora';
import { SecurityOverviewPage } from '@/pages/security-overview';
import { SettingsPage } from '@/pages/settings';
import { LoginPage } from '@/pages/login';
import { isAuthenticated, subscribe, checkSession } from '@/lib/auth';

function useAuth() {
  const authed = useSyncExternalStore(subscribe, isAuthenticated);
  useEffect(() => {
    checkSession();
  }, []);
  return authed;
}

export function App() {
  const authed = useAuth();

  if (!authed) {
    return <LoginPage />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<EcosystemPage />} />
          <Route path="/products/:slug" element={<ProductDetailPage />} />
          <Route path="/dora" element={<DoraPage />} />
          <Route path="/security" element={<SecurityOverviewPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
